import { ACTIONS } from './connectionUtils'

interface ingredient {
  id: number
  name: string
}

interface IngredientResponse {
  success: boolean
  ingredients?: ingredient[]
  error?: string
}

async function getIngredientList(user: string): Promise<IngredientResponse> {
  try {
    const response = await fetch('/api/ingredient', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: ACTIONS.GET,
        user,
      }),
    })
    const data: IngredientResponse = await response.json()
    return data
  } catch (error) {
    console.error('Ingredient error:', error)
    throw error
  }
}

export { getIngredientList }
export type { ingredient }
